export default [
    {
        id: 1,
        label: {
            en: 'Scheduled',
            et: 'Planeeritud',
            ru: 'Запланировано',
            lv: "Ieplānots",
            lt: "Suplanuota",
            fi: "Ajastettu",
        },
        // color: 'green',
        color: 'yellow',
    },
    {
        id: 3,
        label: {
            en: 'Sent',
            et: 'Saadetud',
            ru: 'Отправлено',
            lv: "Nosūtīts",
            lt: "Išsiųsta",
            fi: "Lähetetty",
        },
        // color: 'blue',
        color: 'dark-blue'
    },
    {
        id: 5,
        label: {
            en: 'Overdue',
            et: 'Aegunud',
            ru: 'Просрочено',
            lv: "Kavēts",
            lt: "Pradelsta",
            fi: "Myöhässä",
        },
        color: 'red'
    },
    {
        id: 7,
        label: {
            en: 'Error',
            et: 'Viga',
            ru: 'Ошибка',
            lv: "Kļūda",
            lt: "Klaida",
            fi: "Virhe",
        },
        color: 'red'
    }
]